import { DashboardWidgetName } from './enums'
import { DashboardWidgetParams } from './types'

import {
  Bars4Icon,
  CalendarDaysIcon,
  ChartBarIcon,
  ChartPieIcon,
  EqualsIcon,
  QueueListIcon,
  RectangleGroupIcon,
  Squares2X2Icon,
  TableCellsIcon,
} from '@heroicons/vue/24/outline'
import TreeIcon from '@/assets/images/icons/tree.svg'


export const WIDGETS_LIST: DashboardWidgetParams[] = [
  {
    label: 'Linked Transactions',
    name: DashboardWidgetName.LinkedTransactions,
    section: 'Linked Data',
    icon: Bars4Icon,
  },
  {
    label: 'Linked Transactions Pivot',
    name: DashboardWidgetName.LinkedTransactionsPivot,
    section: 'Linked Data',
    icon: RectangleGroupIcon,
  },
  {
    label: 'Accounts By Type',
    name: DashboardWidgetName.AccountsByType,
    section: 'Value',
    icon: QueueListIcon,
  },
  {
    label: 'Value Pie Chart',
    name: DashboardWidgetName.ValueHistoryPieChart,
    section: 'Value',
    icon: ChartPieIcon,
  },
  {
    label: 'Value Table',
    name: DashboardWidgetName.ValueHistoryTable,
    section: 'Value',
    icon: TableCellsIcon,
  },
  {
    label: 'Value History',
    name: DashboardWidgetName.ValueHistoryBarsChart,
    section: 'Value',
    icon: ChartBarIcon,
  },
  {
    label: 'Value Pivot',
    name: DashboardWidgetName.ValuePivot,
    section: 'Value',
    icon: RectangleGroupIcon,
  },
  {
    label: 'Income Table',
    name: DashboardWidgetName.IncomeHistoryTable,
    section: 'Income',
    icon: TableCellsIcon,
  },
  {
    label: 'Income History',
    name: DashboardWidgetName.IncomeHistoryBarsChart,
    section: 'Income',
    icon: ChartBarIcon,
  },
  {
    label: 'Income Pivot',
    name: DashboardWidgetName.IncomePivot,
    section: 'Income',
    icon: RectangleGroupIcon,
  },
  {
    label: 'Performance Pivot',
    name: DashboardWidgetName.PerformancePivot,
    section: 'Other Analytics',
    icon: RectangleGroupIcon,
  },
  {
    label: 'Commitments',
    name: DashboardWidgetName.Commitments,
    section: 'Other Analytics',
    icon: TableCellsIcon,
  },
  {
    label: 'Cash Flow Projections',
    name: DashboardWidgetName.CashFlowProjections,
    section: 'Other Analytics',
    icon: CalendarDaysIcon,
  },
  {
    label: 'Organization Chart',
    name: DashboardWidgetName.OrganizationChart,
    section: 'Other Analytics',
    icon: TreeIcon,
  },
  {
    label: 'Tree Pivot',
    name: DashboardWidgetName.TreePivot,
    section: 'Other Analytics',
    icon: RectangleGroupIcon,
    // Value Pivot carries the per-path data now; existing Tree Pivots keep rendering.
    hidden: true,
  },
  {
    label: 'Value Change Snapshot',
    name: DashboardWidgetName.ValueChangeSnapshot,
    section: 'Mobile',
    icon: Squares2X2Icon,
  },
  {
    label: 'Income Change Snapshot',
    name: DashboardWidgetName.IncomeChangeSnapshot,
    section: 'Mobile',
    icon: Squares2X2Icon,
  },
  {
    label: 'Section Delimiter',
    name: DashboardWidgetName.SectionDelimiter,
    section: 'Additional',
    icon: EqualsIcon,
  },
  {
    label: 'IRR & MOIC',
    name: DashboardWidgetName.IrrMoic,
    section: 'Other Analytics',
    icon: TableCellsIcon,
  },
]

export const CHART_MAX_SLICES = 7

export const UNPROTECTABLE_WIDGETS = [
  DashboardWidgetName.AccountsByType,
  DashboardWidgetName.SectionDelimiter,
  DashboardWidgetName.ValueChangeSnapshot,
]
